import React, { useState } from 'react';
import { patchChildJournal } from 'child-journals/api';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import store from 'store';
import useEntity from 'entities/hooks/use-entity';
import { Text, Flex } from 'rebass';
import TextField from 'app/form/formik/text/index';
import Wrapper from './Wrapper';
import useMatch from 'app/hooks/match';
import useEntityActionCreators from 'entities/hooks/use-entity-action-creators';
import { prepareAttrs } from 'utils/api';
import GiftCertificateStyle from 'app/payment/GiftCertificateStyle';

export const label = (text, isRequired, subText) => <Text
    color="codGrey"
    sx={{
        fontFeatureSettings: 'liga off, calt off',
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px', /* 142.857% */
        letterSpacing: '-0.084px',
    }}> {text} {isRequired && <span style={{ color: 'red' }}>*</span >}<Text as="span" fontWeight={400} color="rgba(0, 0, 0, 0.60)" fontFamily="Poppins" fontSize={15} letterSpacing="-0.3px">{subText}</Text></Text >


const FieldText = ({ name, type, disabled, placeholder, ...props }) => {
    return <Field
        component={TextField}
        name={name}
        type={type}
        showError
        placeholder={placeholder}
        m="auto"
        borderRadius='31px'
        sx={{
            width: 'inherit',
            borderColor: '#D9D9D9',
            cursor: disabled && 'not-allowed',
            borderRadius: '31px'
        }}
        {...props}
    />
}

const Step3 = ({ onStepDown, onStepUp, journalId, attributes,
    setBookCoverId,
    book_cover_id,
}) => {
    const { params: query } = useMatch();

    const { entity: childJournal } = useEntity({ type: 'child-journals', id: query?.id || journalId });

    const updatedJournalDetails = attributes || childJournal

    const { receive } = useEntityActionCreators();

    const onSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        const body = prepareAttrs({ ...values, book_cover_id, 'lock-version': childJournal['lock-version'] });

        const cjRes = await patchChildJournal({ id: (journalId || updatedJournalDetails?.id), ...body });
        const [id] = cjRes.data.result['child-journals'];
        receive({ payload: cjRes });
        store.remove('child_journal_id')
        // push(`/child-journals/${id || journalId}`);
        onStepUp()
        setSubmitting(false);
    }

    return (
        <Formik
            initialValues={{
                'name': (attributes?.name || '').replace('Journal', 'First Year'),
                // 'number_of_books': 1,
            }}
            enableReinitialize
            validationSchema={Yup.object().shape({
                'name': Yup.string().required(),
                // 'number_of_books': Yup.number().required(),
            })}
            onSubmit={onSubmit}
        >
            {({ values, isSubmitting, setFieldValue, handleSubmit }) => (
                <Form>
                    <Wrapper
                        onSubmit={handleSubmit}
                        onStepUp={onStepUp}
                        onStepDown={onStepDown}
                        onBack={onStepDown}
                        backText="Step 3 of 3"
                        isSubmitting={isSubmitting}
                        percentComplete={75}
                        heading='Introduce Us to Your Little Star'
                        subHeading="Add your baby's details to create a personalized journey of memories, milestones, and moments."
                        bg="aliceBlue"
                        nextButtonText="Continue"
                    >
                        <Flex flexDirection="column" m="auto" mb={0} maxWidth={700}>
                            {/* {pathname.includes('get-started') && !isFromMobile && <IoIosArrowRoundBack size={30} style={{ cursor: 'pointer' }} onClick={onStepDown} />}
                            <Text
                                sx={{
                                    color: "#34495E",
                                    textAlign: "center",
                                    fontFamily: "Poppins",
                                    fontSize: "15px",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "150%",
                                    letterSpacing: "-0.3px",
                                }}
                            >
                                Step 3 of 3
                            </Text> */}
                            <Text
                                color="codGrey"
                                fontFamily="Bitter"
                                fontSize={[24, 28]}
                                lineHeight={["34px", "38px"]}
                                letterSpacing="-0.6"
                                mt={2}
                                mb={1}
                                textAlign="center"
                            >
                                Personalize your book
                            </Text>
                            <Text
                                color="mineShaft"
                                textAlign="center"
                                fontFamily="Poppins"
                                fontSize={[14, 18]}
                                lineHeight={["20px", "28px"]}
                                letterSpacing="-0.6"
                                my={3}
                            >
                                Don’t worry, this is just a starting point!<br />
                                You can easily update the book’s name and style anytime before it’s printed.
                            </Text>

                            <FieldText
                                name="name"
                                placeholder="Name"
                                width="100%"
                                label={label('Book title', true)}
                                my={[2, 4]}
                            />
                            <GiftCertificateStyle
                                isFromBookCover
                                gift_certificate_style_id={book_cover_id || (updatedJournalDetails)?.['book-cover-id']}
                                setGiftCertificateStyleId={(id) => {
                                    setBookCoverId(id);
                                }}
                                name_of_recipient={values?.name}
                            />
                        </Flex>
                    </Wrapper>
                </Form>
            )}
        </Formik>

    );
};

export default Step3;
